<template>
  <transition name="modal">
    <div class="modal-mask" ref="modal">
      <div class="modal-wrapper">
        <div class="modal-container" v-bind:style="{ width, height }">
          <div class="modal-header" v-if="!isEmptyHeader" ref="header">
            <div class="modal-closeButton" v-if="!hideCloseButton" @click="$emit('close')">
              <i class="icon icon--close">X</i>
            </div>
            <div class="modal-header__content">
              <slot name="header"></slot>
            </div>
          </div>

          <div class="modal-body" ref="body">
            <div class="modal-body__content">
              <slot name="body"></slot>
            </div>
          </div>

          <div class="modal-footer" ref="footer">
            <slot name="footer">
              <button class="modal-default-button" @click="$emit('close')">OK</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: ['width', 'height', 'hideCloseButton'],
  data() {
    return {};
  },
  mounted() {
    this.calculateHeight();
  },
  created() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.calculateHeight();
      }, 400);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateHeight);
  },
  computed: {
    isEmptyHeader() {
      return this.$slots.header ? false : true;
    }
  },
  methods: {
    calculateHeight() {
      if (this.$refs['body'] && this.$refs['header']) {
        this.$refs['body'].style.height = `${window.innerHeight -
          this.$refs['header'].clientHeight}px`;
        this.$refs['body'].style.marginTop = `${this.$refs['header'].clientHeight}px`;
      } else if (this.$refs['body']) {
        this.$refs['body'].style.height = `${window.innerHeight}px`;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  display: table;
  transition: opacity 0.3s ease;
  overflow: auto;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  margin: 0 auto;
  font-family: $open-sans;
}

.modal-header {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 40px;
  background: white;
  top: 0;
  padding: 20px 0;
  z-index: 10;
  border-bottom: 1px solid #becdd7;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);

  &__content {
    width: 80%;
    text-align: center;
  }
}

.modal-body {
  position: relative;
  overflow: auto;

  &__content {
    margin-top: 20px;
    padding: 0 30px;
    width: calc(100% - 60px);
  }
}

.modal-default-button {
  float: right;
}

.modal-closeButton {
  justify-content: flex-end;
  position: absolute;
  right: 0;
  z-index: 999;

  .icon {
    display: inline-block;
    width: 50px;
    height: 50px;
    text-indent: -9999px;
    cursor: pointer;

    &--close {
      background: url('../../assets/img/ico-header-close.svg') no-repeat center center;
    }
  }
}

/*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
